import styled from '@emotion/styled'
import { Box, Typography } from '@mui/material'
import React from 'react'
import { Link } from 'react-router-dom'

const ButtonLink = styled(Link)(({ theme }) => ({
  textDecoration: 'unset',
  backgroundColor: theme.palette.primary.main,
  padding: '8px 1rem',
  borderRadius: '8px',
  color: '#fff',
  marginTop: '1rem',
}))

const NotFound = () => {
  return (
    <Box
      display={'flex'}
      flexDirection={'column'}
      alignItems={'center'}
      height={'100%'}
      justifyContent={'center'}
    >
      <Typography color={'error'} variant="h3">
        Oops
      </Typography>
      <Typography>Page Not Found!</Typography>
      <ButtonLink to={'/'}>Home</ButtonLink>
    </Box>
  )
}

export default NotFound
